<template>
  <div>
    <!-- <h1 class="mobiTitle white lg content" id="contentTitle">
      {{ $t('profile') }}
    </h1> -->
    <div class="profileImg">
      <div class="userAccount">
        <div class="userAccount__image">
          <img class="user_img" src="../../assets/mobizone/imgs/dummy_account.jpeg"/>
        </div>
        <div class="userAccount__name">
          <h1 class="mobiTitle md">{{ $t("hello") }}</h1>
        </div>
      </div>
    </div>
    <div class="main_wrap">
      <div class="mobiSection">
        <div class="mobiSection__content">
          <div class="userProfile">
            <div class="inputWrap">
              <label for="" class="inputWrap__label text_color">{{ $t('registered_num') }}:</label>
              <h2 class="mobiTitle md text_color">{{msisdn_mobiz}}</h2>
            </div>
            <div class="inputWrap">
              <label for="" class="inputWrap__label text_color">{{ $t('subscription_date') }}:</label>
              <h2 class="mobiTitle md text_color">{{subscription_date_mobiz}}</h2>
            </div>  
            <div class="inputWrap" v-if="country_mobiz !== 'bh'">
              <label for="" class="inputWrap__label text_color">{{ $t('next_renew_date') }}:</label>
              <h2 class="mobiTitle md text_color">{{renew_date_mobiz}}</h2>
            </div>
            <div class="inputWrap" v-else>
              <label for="" class="inputWrap__label text_color">{{ $t('current_status') }}:</label>
              <h2 class="mobiTitle md text_color">{{current_status}}</h2>
            </div>
          </div>
          <div class="btnContainer " v-if="auth_mobiz === 'loggedin'">
            <!-- <div v-if="is_unsub_mobiz != '0'">
              <a @click="logout_mobiz(is_unsub_mobiz)" style="text-decoration:none; color: white" class="mobiBtn">{{ $t("unsubscribe") }}</a>
            </div>
            <div v-else>
              <a @click="logout_mobiz(is_unsub_mobiz)" href="/logout" class="mobiBtn">{{ $t("unsubscribe") }}</a>
            </div> -->
            <div v-if="country_mobiz == 'iq' || country_mobiz == 'bh'">
                <a style="text-decoration:none; color: white; text-align:center" class="mobiBtn" data-toggle="modal" data-target="#exampleModalCenter">
                  {{ $t("unsubscribe") }}
                </a>
              </div>
              <div v-else>
                <a @click="logout_mobiz(is_unsub_mobiz)" style="text-decoration:none; color: white; text-align:center" class="mobiBtn">{{ $t("unsubscribe") }}</a>
              </div>
          </div>
        </div>
      </div>
    </div>  
    
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
var TJO = require("translate-json-object")();

export default {
  data() {
    return {
      current_status: "",
    };
  },
  computed: mapGetters([
    "msisdn_mobiz",
    "renew_date_mobiz",
    "subscription_date_mobiz",
    "auth_mobiz",
    "is_unsub_mobiz",
    "status_mobiz",
    "country_mobiz",
    "langcode_mobiz"
  ]),
  mounted(){
    this.current_status = this.status_mobiz
  },
  updated(){
    TJO.init({
      googleApiKey: 'AIzaSyCq1acQaQt46Yx2VK1BrlYm19SN7hqbf04',
      // yandexApiKey: "trnsl.1.1.20191111T072241Z.a4ad72c3f47a325f.7a1d4907e47128f839d39d2241ed3fcc0414ada7"
    });

    var curr_status = {
      status: this.status_mobiz,
    };

    TJO.translate(curr_status, this.langcode_mobiz).then((data) => {
      this.current_status = data.status
    })
    .catch(function(err) {
      console.log("error ", err);
    });
  },
  methods: {
    ...mapActions(["logout_mobiz"])
  }
};
</script>

<style scoped lang="scss">
.profileImg {
  margin-bottom: 3rem;
  text-align: center;
  .mobiTitle {
    color: #fff;
  }
}
.userAccount__image {
  width: 92px;
  height: 92px;
  position: relative;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 50%;
  img {
    width: 100%;
  }
}
.userAccount__name {
  p {
    color: #000;
  }
  margin-top: 15px;
}
.ar_layout {
  .userAccount__name .mobiTitle {
    text-align: center;
  }
  .inputWrap {
    text-align: right;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mobizone/Profile.vue